/**
* 头部菜单
*/ 
<template>
  <div class="nav">
      <!-- active-text-color="#ff821c" -->
    <el-menu 
      class="el-menu-demo"
      mode="horizontal" 
      background-color="#fff"
      :default-active="activeMenu"  
      text-color="#333"
      >
        <img class="logo" src="../assets/img/logo.png" alt="">
        <div class="nav-list">
          <el-menu-item 
            v-for="item,index in menuItem" 
            :index="item.url"
            :key="index"
            >
            <router-link class="router_title" :class="activeMenu==item.url?'router_title_nav':''" :to="item.url">{{item.name}}</router-link>
          </el-menu-item>
        </div>
    </el-menu>
    <el-menu class="el-menu-demo" mode="horizontal" background-color="#fff" text-color="#333" active-text-color="#333">
      <div class="nav-right">
        <div class="search">
          <el-input placeholder="请输入内容" v-model="inputValue" class="input-with-select">
            <el-select v-model="select" slot="prepend" placeholder="请选择">
              <el-option label="课程" value="1"></el-option>
              <el-option label="直播" value="2"></el-option>
              <el-option label="考试中心" value="3"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" @click="handleSubmit"></el-button>
          </el-input>
          <!-- <el-input
            size="small"
            placeholder="请输入搜索内容"
            suffix-icon="el-icon-search"
            v-model="inputValue"
            @keyup.enter="handleSubmit"
            >
          </el-input> -->
        </div>
        <el-button size="small" type="warning" @click="onLogin" style="background-color: #ff821c" v-if="!username">登录 / 注册</el-button>
        <el-button size="small" type="warning" @click="onPersonal" style="background-color: #ff821c" v-else>个人中心</el-button>
      </div>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: 'navcon',
  data() {
    return {
      activeMenu:'/index/index',
      username:localStorage.getItem('username'),
      user: {},
      inputValue:'',
      select:''
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
    let res = {
      success: true,
      data: [
        {
          name:'首页',
          url:'/index/index'
        },
        {
          name:'课程',
          url:'/index/classroom'
        },
        {
          name:'直播',
          url:'/index/live'
        },
        {
          name:'考试中心',
          url:'/index/exam'
        },
        {
          name:'服务与支持',
          url:'/index/support?id=1'
        },
        {
          name:'证书查询',
          url:'/index/search'
        }
      ],
      msg: 'success'
    }
    this.menuItem = res.data
    // 在组件创建时设置默认高亮的菜单项
    this.activeMenu = this.$route.path;
    // 添加路由监听器以更新高亮项
    this.$router.afterEach((to, from) => {
      this.activeMenu = to.path;
    });
  },
  methods: {
    onPersonal(){
      sessionStorage.setItem('keyPath', 0);
      this.$router.push({path:'/personal/personal'})
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    onLogin(){
      this.$router.push({path:'/login/login'})
    },
    handleSubmit(){
    console.log("this.select",this.select)
      if(!this.select){
        this.$message({
          message: '请选择搜索类型',
          type: 'warning',
          offset:100
        });
        return
      }
      if(this.select == 1){
        this.$router.push({path:'/index/classroom',query:{keyWord:this.inputValue}})
      }else if(this.select == 2){
        this.$router.push({path:'/index/live',query:{keyWord:this.inputValue}})
      }else{
        this.$router.push({path:'/index/exam',query:{keyWord:this.inputValue}})
      }
    }
  }
}
</script>
<style scoped>
@media (min-width: 1366px) {
  .nav {
    width: 1280px;
  }
}
@media (min-width: 1600px) {
  .nav {
    width: 1500px;
  }
}
.nav{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: auto;
  padding: 8px;
}
.logo{
  width: 160px;
  margin-right: 30px;
}
.nav /deep/ .el-menu.el-menu--horizontal{
  border-bottom: none;
}
.el-menu-demo{
  display: flex;
  align-items: center;
}
.nav-list{
  display: flex;
  align-items: center;
}
.nav /deep/ .el-menu-item{
  font-size: 13px;
}
.nav /deep/ .el-menu-item:hover{
  background: none !important;
}
/* .nav /deep/ .is-active{
  border-bottom: 2px solid #ff821c;
} */
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.nav-right{
  display: flex;
  align-items: center;
}
.search{
  margin-right: 50px;
}
/* .search /deep/ .el-input__inner{
  border-radius: 30px; */
  /* height: 35px;
} */
.search /deep/ .el-input-group__prepend{
  width: 50px;
}
a{
  color: inherit;
  text-decoration: none;
  outline: none;
}
.el-menu-item.is-active{
  color: #333;
}
.router_title:hover{
  color: #ff821c;
}
.router_title_nav{
  color: #ff821c;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue